// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IConfirmSignUpRequestDto
 */
export interface IConfirmSignUpRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IConfirmSignUpRequestDto
     */
    hash_id: string;
    /**
     * 
     * @type {string}
     * @memberof IConfirmSignUpRequestDto
     */
    confirmation_code: string;
}

/**
 * Check if a given object implements the IConfirmSignUpRequestDto interface.
 */
export function instanceOfIConfirmSignUpRequestDto(value: object): value is IConfirmSignUpRequestDto {
    if (!('hash_id' in value) || value['hash_id'] === undefined) return false;
    if (!('confirmation_code' in value) || value['confirmation_code'] === undefined) return false;
    return true;
}

export function IConfirmSignUpRequestDtoFromJSON(json: any): IConfirmSignUpRequestDto {
    return IConfirmSignUpRequestDtoFromJSONTyped(json, false);
}

export function IConfirmSignUpRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IConfirmSignUpRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'hash_id': json['hash_id'],
        'confirmation_code': json['confirmation_code'],
    };
}

export function IConfirmSignUpRequestDtoToJSON(json: any): IConfirmSignUpRequestDto {
    return IConfirmSignUpRequestDtoToJSONTyped(json, false);
}

export function IConfirmSignUpRequestDtoToJSONTyped(value?: IConfirmSignUpRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hash_id': value['hash_id'],
        'confirmation_code': value['confirmation_code'],
    };
}

